import { rest as API } from './rest';

const basePath = ({ customerUUID, ecosystemUUID }) =>
  `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/devices`;

export const getDevicesList = (params) => API.get(basePath(params)).then(({ data }) => data);

export const getDeviceDetail = (params) => API.get(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);

export const createDevice = (params) => API.post(basePath(params), params.payload).then(({ data }) => data);

export const updateDevice = (params) =>
  API.put(`${basePath(params)}/${params.uuid}`, params.payload).then(({ data }) => data);

export const deleteDevice = (params) => API.delete(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);

export const getDevicesSessions = (params) => API.get(`${basePath(params)}/sessions`).then(({ data }) => data);

export const createDeviceToken = (params) =>
  API.post(`${basePath(params)}/${params.uuid}/tokens`, params.payload).then(({ data }) => data);

export const getThingToken = (params) =>
  API.post(`${basePath(params)}/${params.uuid}/token`).then((response) => response.data);
